import formPage from './formPage/initialState';
import formData from './formData/initialState';
import snacks from './snacks/initialState';

export const initialState = {
  snacks,
  formPage,
  formData
};
